import Profile from 'components/mypage/Profile';
import React from 'react';

const MyPage = () => {
  return <Profile />;
};

export default MyPage;
